import axios from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';
import { IServer } from '@/shared/model/server.model';

const baseApiUrl = 'api/private/servers';

export default class ServerService {
  /**
   * fetch by organization id
   * @param id
   */
  public find(id: number): Promise<IServer> {
    return new Promise<IServer>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public findDefaultServer(): Promise<IServer> {
    return new Promise<IServer>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/1`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public create(entity: IServer): Promise<IServer> {
    return new Promise<IServer>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public update(entity: IServer): Promise<IServer> {
    return new Promise<IServer>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
